<template>
  <app-loading :loading="loading">
    <div>
      <app-header v-if="homeworks.length" numbers :button="false">
        <template #title>{{ names[currentHomework.type] }}</template>
        <template #current-step>{{ model + 1 }}</template>
        <template #max-step>{{ homeworks.length }}</template>
      </app-header>
      <div v-else class="d-flex">
        <div class="title">
          <span v-if="profile.role === 'STUDENT'"> No homework assigned yet. </span>
          <span v-else> No homework available. </span>
        </div>
      </div>
      <v-divider class="mb-3" />
      <div class="d-flex">
        <v-btn
          color="#29284c"
          small
          outlined
          width="140"
          class="text-capitalize ml-auto mt-2"
          @click="backAction"
        >
          {{ backButtonText }}
        </v-btn>
        <v-btn
          color="#FF347C"
          small
          depressed
          width="140"
          class="white--text text-capitalize ml-2 mt-2"
          @click="buttonAction"
        >
          {{ buttonText }}
        </v-btn>
      </div>
      <v-slide-x-transition mode="out-in">
        <keep-alive>
          <component
            :is="currentHomework.type"
            :data="currentHomework"
            :key="currentHomework.uuid"
          />
        </keep-alive>
      </v-slide-x-transition>
    </div>
  </app-loading>
</template>
<script>
import Header from "../Header.vue";
import { getHomeworks } from "@/api/api";
import Loading from "../../../../Loading.vue";
import { mapState } from "vuex";
import Recording from "./Homework/Recording.vue";
import Retelling from "./Homework/Retelling.vue";
import Monologue from "./Homework/Monologue.vue";
import { getHomeworkById } from "@/api/api";

export default {
  components: {
    appHeader: Header,
    appLoading: Loading,
    Recording,
    Retelling,
    Monologue,
  },
  data() {
    return {
      model: Number.parseInt(this.$route.query.hn) || 0,
      homeworks: [],
      loading: false,
      names: {
        Retelling: "Written Retelling",
        Monologue: "Writing Log",
        Recording: "Lesson text recording",
      },
    };
  },
  computed: {
    ...mapState(["profile"]),
    currentHomework() {
      return this.homeworks[this.model] || {};
    },
    location() {
      if (this.$route.name === "practice") {
        return "PRACTICE";
      } else {
        return "LIVE";
      }
    },
    buttonText() {
      return this.model >= this.homeworks.length - 1 ? "Next Step >>" : "Next Homework";
    },
    backButtonText() {
      return this.model <= 0 ? "Previous Step" : "Previous Homework";
    },
  },
  methods: {
    buttonAction() {
      if (this.model >= this.homeworks.length - 1) {
        this.$emit("next-step");
      } else {
        this.model++;
      }
    },
    backAction() {
      if (this.model <= 0) {
        this.$emit("prev-step");
      } else {
        this.model--;
      }
    },
  },
  watch: {
    model(val) {
      this.$router.replace({
        query: { ...this.$route.query, hn: val },
      });
    },
  },
  async mounted() {
    try {
      this.loading = true;
      const params = {
        teacher_lesson__uuid: this.$store.getters["lesson/teacher_lesson"].uuid,
        location: this.location,
      };
      if (this.profile.role === "STUDENT") {
        params.students__student__email = this.profile.email;
      }
      const response = await getHomeworks({ ...params, not_type: "Custom" });
      const homeworks = response.data.results.map((item) => getHomeworkById(item.uuid));
      this.homeworks = (await Promise.all(homeworks)).map((response) => response.data);
    } finally {
      this.loading = false;
    }
  },
};
</script>
